import * as React from 'react';

function SvgDividerBulletFilled(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("circle", { cx: 12, cy: 12, r: 10, fill: "currentColor" })));
}

export default SvgDividerBulletFilled;
